import { type DateFormatOptions, DEFAULT_DATE_FORMAT, formatDate, isDefined } from '@enterprise/core';

/**
 * A custom hook that formats a given date using the specified format options.
 *
 * @param date - The date to format. Can be a `Date` object or a date string.
 * If not provided or undefined, returns `null`.
 * @param format - The format to use for formatting the date.
 * Can be a `DateFormatOptions` object or a string. Defaults to `DEFAULT_DATE_FORMAT`.
 * @returns The formatted date string if the date is defined, otherwise `null`.
 */
export const useDateFormat = (date?: Date | string, format: DateFormatOptions | string = DEFAULT_DATE_FORMAT) => {
  return isDefined(date) ? formatDate(date, format) : null;
};
